import(/* webpackMode: "eager", webpackExports: ["AmplifyConfigure"] */ "/codebuild/output/src1810816620/src/helloero-new/packages/helloero/src/app/AmplifyConfigure.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1810816620/src/helloero-new/packages/shared/components/functional/GlobalScripts/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JotaiProvider"] */ "/codebuild/output/src1810816620/src/helloero-new/packages/shared/components/functional/JotaiProvider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserInfoProvider"] */ "/codebuild/output/src1810816620/src/helloero-new/packages/shared/hooks/useUserInfo.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1810816620/src/helloero-new/packages/tailwind_config/globals.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1810816620/src/helloero-new/packages/tailwind_config/customs.css");
